import React from "react";
import { useSelector } from "react-redux";
import ClassesTeacher from "./teacher/ClassesTeacher";
import ClassesStudent from "./student/ClassesStudent";
import Loader from "./Loader.js";
import PermissionDenied from "./PermissionDenied.js";
import ClassesOnboarding from "./onboarding/ClassesOnboarding";
import ClassesPrincipal from "./principal/ClassesPrincipal";
import ClassesParent from "./parent/ClassesParent";

const Classes = () => {
  const state = useSelector((state) => state);

  if (state.auth.isLoading) {
    return <Loader />;
  } else {
    if (state.auth.user.is_teacher) {
      return <ClassesTeacher />;
    }
    if (state.auth.user.is_student) {
      return <ClassesStudent />;
    }
    if (state.auth.user.is_onboarding) {
      return <ClassesOnboarding />;
    }
    if (state.auth.user.is_principal) {
      return <ClassesPrincipal />;
    }
    if (state.auth.user.is_parent) {
      if (!state.auth.isLoadingStudent) {
        return <ClassesParent />;
      }
      return <Loader />;
    }
    return <PermissionDenied />;
  }
};

export default Classes;
